import script from "./KenyanAuthModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KenyanAuthModal.vue?vue&type=script&setup=true&lang=js"

import "./KenyanAuthModal.vue?vue&type=style&index=0&id=71cd461d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cd461d"]])

export default __exports__